
import { useEffect, useState } from "react"
import { ChevronRight } from "@mui/icons-material"
import { appendClass, combineClass, IGWidget } from "../GWidget"
import TreeNodeSession from "./TreeNodeSession"

export interface ITreeNode<T> {
    _id:string
    name:string
    expanded:boolean
    parentId:string|null

    children:ITreeNode<T>[]
    parent:ITreeNode<T>|null

    addToggleHandler?:(handler:any) => ITreeNode<T>
    removeToggleHandler?:(handler:any) => ITreeNode<T>
}

export interface ITreeNodeProps<T> {
    node:ITreeNode<T>
    selectedId:string
    session:TreeNodeSession<T>|null
    onChange:(node:ITreeNode<T>)=>void
}

function Directory<T extends ITreeNode<T>>(props:{node:T, expanded:boolean, selected: boolean, onClick:()=>void}) {
    const className = combineClass("dir flex middle gap-4", {
        expanded:props.expanded,
        selected:props.selected,
    })
    return <div className={className} onClick={props.onClick}>
        <ChevronRight className="arrow"/>
        {props.node.name}
    </div>
}

export default function TreeNode<T extends ITreeNode<T>>(props:ITreeNodeProps<T>&IGWidget) {
    const {node,selectedId,session,onChange} = props
    const [expanded,setExpanded] = useState<boolean>(node.expanded)

    const onClick = async () => {
        if (props.selectedId!=node._id) {
            node.expanded = true
            session?.toggle(node)
            onChange(node)
            setExpanded(true)            
        }
        else {
            node.expanded = !expanded
            session?.toggle(node)
            setExpanded(!expanded)
        }
    }

    const onToggle = (node:ITreeNode<T>) => setExpanded(node.expanded)

    useEffect(() => {
        node.addToggleHandler?.(onToggle)
        return () => {node.removeToggleHandler?.(onToggle)}
    },[])

    const nodes = expanded && node.children.length ? node.children.map(child => <TreeNode node={child} key={child._id} selectedId={selectedId} session={session} onChange={onChange}/>) : null
    return <div className={appendClass("treenode", props.className)}>
        <Directory node={node} expanded={expanded} selected={selectedId==node._id} onClick={onClick}/>
        {nodes?.length ? <div className="indent">{nodes}</div> : null}
    </div>
}
